import React from "react";

import { OnlineLink, SupportLevelIcon } from "components";
import { getFullName } from "helpers";
import { getInstallationAppLink, getAppStatuses } from "mappers";

import styles from "../search.module.scss";

export const installationResultItem = (obj): { [key: string]: any } => {
	return (
		<div
			className={`${styles.wrappSearchInfo} flex-wrap`}
			style={{ justifyContent: "flex-start" }}
		>
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>App ID:</p>
					{obj?.id && (
						<OnlineLink
							to={getInstallationAppLink(
								obj?.application_status,
								obj?.id,
							)}
							target="_blank"
							style={{ marginLeft: "15px" }}
						>
							{obj?.number}
						</OnlineLink>
					)}
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>MID:</p>
					<div className={styles.content}>
						{obj?.mid && obj?.merchant_id && (
							<p className="d-flex">
								<SupportLevelIcon name={obj?.priority_type} />
								<OnlineLink
									to={`/merchant/list/info/${obj?.merchant_id}/general`}
									target="_blank"
									style={{ marginLeft: "7px" }}
								>
									{obj?.mid}
								</OnlineLink>
							</p>
						)}
					</div>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>DBA Name:</p>
					<p className={`break-word ${styles.content}`}>
						{obj.merchant_name}
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Agent Office & Agent:</p>
					<div className={styles.content}>
						{obj.agent_office_id && obj?.agent_office && (
							<p className="mb-0">
								<OnlineLink
									to={`/system-setup/agent-office-setup/edit-agent-office/${obj.agent_office_id}/general-info`}
									target="_blank"
								>
									{obj?.agent_office?.name}
								</OnlineLink>
							</p>
						)}
						{obj?.agent_id && obj?.agent && (
							<p className="mb-0">
								<OnlineLink
									to={`/system-setup/agent-setup/edit-agent/${obj?.agent_id}/general-info`}
									target="_blank"
								>
									{getFullName(obj?.agent)}
								</OnlineLink>
							</p>
						)}
					</div>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>
						Installation Request Status:
					</p>
					<p className={styles.content}>
						{getAppStatuses(obj.application_status)}
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Assigned to:</p>
					<p className={styles.content}>
						{getFullName(obj?.installation_assignee)}
					</p>
				</div>
			}
		</div>
	);
};
